import { render, staticRenderFns } from "./SubastaProducto.vue?vue&type=template&id=29654a12"
import script from "./SubastaProducto.vue?vue&type=script&lang=js"
export * from "./SubastaProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports